/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: queue-detail-view-controller
 *
 * Created by rwilliams on 3/29/17.
 */
'use strict';

function QueueDetailViewController(
    _,
    $interval,
    $location,
    $q,
    $routeParams,
    BreadcrumbService,
    ModalService,
    NavbarUtilService,
    PaginationService,
    PermissionsService,
    QueuesViewService,
    RequestService
) {
    var self = this;
    var pollingFrequency = 10000;


	//==================//
	// View Permissions //
    //==================//

	var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';

    self.canOpenVideoModel = function (media) {
        return self.queuePermissions.preview.read;
    };

	self.canEditPriority = function (queueStep) {
        return queueStep.status === 'QUEUED' && PermissionsService.isAdmin();
    };

    var getColumnsToExclude = function () {
        var statusTab = $location.search().status;
        var queueGroup = $routeParams.group;
        var excludedColumns = [];

        if (statusTab === 'active') {
            excludedColumns = _.concat(excludedColumns, 'endTime');
        } else {
            excludedColumns = _.concat(excludedColumns, 'percentComplete', 'bandwidth', 'eTA');

            if (statusTab !== 'finished') {
                excludedColumns = _.concat(excludedColumns, 'endTime');
            }
        }

        // Group Specific
        if (queueGroup === 'transcodes') {
            excludedColumns = _.concat(excludedColumns, 'bandwidth', 'eTA', 'airTime');
        }

        if (queueGroup === 'fileCopy' || queueGroup === 'restores') {
            excludedColumns = _.concat(excludedColumns, 'bandwidth', 'eTA');
        }

        return excludedColumns;
    };


    //======//
    // Data //
    //======//

	var getDataQuery = function () {
        var offset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
        var searchText = $location.search().searchText;
        var queryOpts = {
            id: $routeParams.id,
            filter: self.currentTab,
            fetchOffset: offset,
            fetchLimit: self.pagingOptions.pageSize,
        };
        if (searchText) {
            queryOpts.searchString = searchText.toLowerCase();
        }
        if (self.currentTab === 'active') {
            queryOpts.filter = 'active|queued';
        }
        return QueuesViewService.getQueueStepData(queryOpts);
    };

	var loadQueueSteps = function () {
		self.loadingIndicator.show = true;
		if (self.pollingInterval) {
			$interval.cancel(self.pollingInterval);
			self.pollingInterval = null;
		}

        RequestService.queryForNewData(getDataQuery, (data) => _.isEmpty(data.stepData))
        .then(function (data) {
            self.breadcrumbTabName = self.queueName = data.queueData.name;
            self.excludedColumns = getColumnsToExclude();
            self.queueSteps = data.stepData;
        }).finally(function() {
            self.pollingInterval = $interval(loadQueueSteps, pollingFrequency);
            self.loadingIndicator.show = false;
        });
	};


	//============//
    // Pagination //
    //============//

	self.paginationPrevPageHandler = function () {
		--self.pagingOptions.currentPage;
		loadQueueSteps();
	};

	self.paginationNextPageHandler = function () {
		++self.pagingOptions.currentPage;
		loadQueueSteps();
	};

	self.paginationPageSizeChanged = function () {
		self.pagingOptions.updateCurrentPage();
		loadQueueSteps();
	};

	self.paginationJumpToPageHandler = function () {
		loadQueueSteps();
	};


    //===================//
    // Template Response //
    //===================//

    self.onStepPrioritiesChanged = function(queueSteps) {
        self.loadingIndicator.show = true;
        var promises = _.map(queueSteps, function (queueStep) {
            return QueuesViewService.saveQueueStep(queueStep)
            .then(function (entity) {
                queueStep.priorityOverride = entity.priorityOverride;
                queueStep.priority = null;
            });
        });

        $q.all(promises).then(function () {
            loadQueueSteps();
        });
    };

    self.activateTab = function (tab) {
        QueuesViewService.getQueueViewPermissions(PREVIEW_TAB_VIEW_STATE).then(function (permissions) {
            self.queuePermissions.preview.read = permissions.preview;

            $location.search('status', tab);
            if (self.currentTab !== tab) {
                self.currentTab = tab;
                loadQueueSteps();
            }
        });
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

	self.$onInit = function () {
        self.queuePermissions = {
            read: false,
            write: false,
            clone: {
                read: false,
                write: false,
                batch: {
                    write: false
                }
            },
            preview: {
                read: false
            }
        };

        self.pagingOptions = PaginationService;
        self.currentPageSize = self.pagingOptions.pageSize;
        self.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        self.excludedColumns = getColumnsToExclude();
		NavbarUtilService.viewSearchFunction = function () {
			loadQueueSteps(self.currentTab);
		};
	};

    self.$postLink = function () {
        self.activateTab($location.search().status || 'active');
        BreadcrumbService.updateBreadcrumbs(QueuesViewService.breadcrumb);
    };

    self.$onDestroy = function () {
        $interval.cancel(self.pollingInterval);
            self.pollingInterval = null;
    };
}

angular.module('prism-ui.queues').component('queueDetailView', {
    templateUrl: 'dashboard/queues/queueDetail/queue-detail-view-template.html',
    controller: QueueDetailViewController
});
